import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booking-button-enabler"
export default class extends Controller {
  static targets = ["input", "button"];

  connect() {
    this.checkInputs();
    this.inputTargets.forEach(input => {
      console.log(input, input.value);
      input.addEventListener("input", () => this.checkInputs());
      input.addEventListener("change", () => this.checkInputs());
    });
  }

  checkInputs() {
    const allFilled = this.inputTargets.every(input => input.value && input.value.trim() !== "");
    if (allFilled) {
      this.buttonTarget.classList.remove("btn-disabled");
    } else {
      this.buttonTarget.classList.add("btn-disabled");
    }
  }
}
